import { useId, useState } from "react";

import { FormControl } from "./FormControl";

export const RoleSelect: React.FC<{
  defaultRole?: string;
  defaultLevel?: string;
}> = ({ defaultRole = "", defaultLevel }) => {
  const id = useId();
  const [role, setRole] = useState(defaultRole);
  return (
    <FormControl id={id} label="I am a...">
      <div className="join">
        <select
          id={id}
          className="join-item select select-bordered w-full"
          name="role"
          value={role}
          onChange={(event) => {
            setRole(event.target.value);
          }}
        >
          <option value="">Please select one (optional)</option>
          <option value="teacher">Teacher</option>
          <option value="student">Student</option>
          <option value="parent">Parent</option>
          <option value="other">Other</option>
        </select>
        {role === "teacher" && (
          <select
            className="join-item select select-bordered w-full"
            name="level"
            defaultValue={defaultLevel}
          >
            <option value="elementary">Grades 1-4</option>
            <option value="middle">Grades 5-8</option>
            <option value="high">Grades 9-12</option>
            <option value="higher">Post-secondary</option>
            <option value="continuing">Continuing education</option>
            <option value="other">Other</option>
          </select>
        )}
      </div>
    </FormControl>
  );
};
